import { Component, Shark } from "shark-mvc";
import FileSaver from "file-saver";

import templateContent from "./export-PDF.html";

import waitBoxComponent from "../waitBox/waitBoxComponent";

class ExportPDFComponent extends Component {
	constructor () {
		super("exportPDFComponent");
		this.addTemplate("", templateContent);
	}

	convertToPDF () {
		const documentToExport = this.get("documentToExport");
	
		if (documentToExport && documentToExport.isDirty()) {
			alert("Hai apportato delle modifiche che non sono state salvate.\nPer favore, salva le modifiche prima di proseguire.");
			return;
		}
	
		const documentSaveName = this.get("documentSaveName") || "IPM";
		waitBoxComponent.open();
	
		const printContent = this.getPrintContent();
		this.requestRemotePDF(printContent, documentSaveName);
	}

	convertToPDFBtn_clickHandler () {
		this.convertToPDF();
	}

	init () {
		this.addComponents([waitBoxComponent]);
	}

	isTouchDevice () {
		var prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
		var mq = function (query) {
			return window.matchMedia(query).matches;
		};
	
		if (("ontouchstart" in window) || window.DocumentTouch && document instanceof DocumentTouch) {
			return true;
		}
	
		// include the "heartz" as a way to have a non matching MQ to help terminate the join
		// https://git.io/vznFH
		var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
		return mq(query);
	}
	
	getPrintContent () {
		document.querySelectorAll(`[data-role="visible-content"] input[type="checkbox"], [data-role="visible-content"] input[type="radio"]`).forEach(item => {
			document.querySelectorAll(`[data-role="print-content"] [data-sh-prop="${item.dataset.shProp}"]`).forEach(input => {
				if (input.value === item.value) {
					if (item.checked) {
						input.setAttribute("checked", "checked");
					}
					else {
						input.removeAttribute("checked");
					}
				}
			});
		});
	
		document.querySelectorAll(`[data-role="print-content"] [data-type="textarea"]`).forEach(item => {
			item.innerHTML = item.innerHTML.replace(/\n/g, "<br>");
		});
	
		const printContent = document.querySelector("html").cloneNode(true);
		printContent.querySelectorAll("body >:not(.print-page):not(.modal-print-page)").forEach(node => node.remove());
	
		return printContent;
	}
	
	requestRemotePDF (printContent, documentSaveName) {
		const isTouchDevice = this.isTouchDevice();
		const requestHeaders = new Headers();
		requestHeaders.append("Authorization", "Token: api_public_f0abac81f265464e8d283c9d208f5b6c");
		requestHeaders.append("Content-Type", "application/json");
	
		fetch("https://api.sejda.com/v2/html-pdf", {
			body: JSON.stringify({
				filename: documentSaveName + ".pdf",
				pageSize: "a4",
				htmlCode: printContent.innerHTML,
				usePrintMedia: true,
			}),
			headers: requestHeaders,
			method: "POST",
		})
		.then(response => {
			return response.blob();
		})
		.then(data => {
			if (isTouchDevice) {
				window.open(self.URL.createObjectURL(data));
			}
			else {
				FileSaver.saveAs(data, documentSaveName + ".pdf");
			}
			waitBoxComponent.close();
		})
		.catch(error => {
			console.error(error);
			alert("Mi spiace, si è verificato un errore.");
			waitBoxComponent.close();
		});
	}
}

const exportPDFComponent = new ExportPDFComponent();

// exportPDFComponent.addMethod("convertToPDFBtn_clickHandler", function () {
// 	const documentToExport = this.get("documentToExport");

// 	if (documentToExport && documentToExport.isDirty()) {
// 		alert("Hai apportato delle modifiche che non sono state salvate.\nPer favore, salva le modifiche prima di proseguire.");
// 		return;
// 	}

// 	const documentSaveName = this.get("documentSaveName") || "IPM";
// 	waitBoxComponent.open();

// 	const printContent = this.getPrintContent();

// 	// document.querySelectorAll(`[data-role="visible-content"] input[type="checkbox"], [data-role="visible-content"] input[type="radio"]`).forEach(item => {
// 	// 	document.querySelectorAll(`[data-role="print-content"] [data-sh-prop="${item.dataset.shProp}"]`).forEach(input => {
// 	// 		if (input.value === item.value) {
// 	// 			if (item.checked) {
// 	// 				input.setAttribute("checked", "checked");
// 	// 			}
// 	// 			else {
// 	// 				input.removeAttribute("checked");
// 	// 			}
// 	// 		}
// 	// 	});
// 	// });

// 	// document.querySelectorAll(`[data-role="print-content"] [data-type="textarea"]`).forEach(item => {
// 	// 	item.innerHTML = item.innerHTML.replace(/\n/g, "<br>");
// 	// });

// 	// const printContent = document.querySelector("html").cloneNode(true);
// 	// printContent.querySelectorAll("body >:not(.print-page):not(.modal-print-page)").forEach(node => node.remove());

// 	const isTouchDevice = this.isTouchDevice();
// 	const requestHeaders = new Headers();
// 	requestHeaders.append("Authorization", "Token: api_public_f0abac81f265464e8d283c9d208f5b6c");
// 	requestHeaders.append("Content-Type", "application/json");

// 	fetch("https://api.sejda.com/v2/html-pdf", {
// 		body: JSON.stringify({
// 			filename: documentSaveName + ".pdf",
// 			pageSize: "a4",
// 			htmlCode: printContent.innerHTML,
// 			usePrintMedia: true,
// 		}),
// 		headers: requestHeaders,
// 		method: "POST",
// 	})
// 	.then(response => {
// 		return response.blob();
// 	})
// 	.then(data => {
// 		if (isTouchDevice) {
// 			window.open(self.URL.createObjectURL(data));
// 		}
// 		else {
// 			FileSaver.saveAs(data, documentSaveName + ".pdf");
// 		}
// 		waitBoxComponent.close();
// 	})
// 	.catch(error => {
// 		console.error(error);
// 		alert("Mi spiace, si è verificato un errore.");
// 		waitBoxComponent.close();
// 	});

// 	// SejdaJsApi.htmlToPdf({
// 	// 	filename: documentSaveName + ".pdf",
// 	// 	pageSize: "a4",
// 	// 	publishableKey: "api_public_f0abac81f265464e8d283c9d208f5b6c",
// 	// 	htmlCode: printContent.innerHTML,
// 	// 	usePrintMedia: true,
// 	// 	always: function(data) {
// 	// 		console.log(data);
// 	// 		waitBoxComponent.close();
// 	// 	},
// 	// 	success: function(data) {
// 	// 		console.log("success", data);
// 	// 		waitBoxComponent.close();
// 	// 	},
// 	// 	error: function(err) {
// 	// 		console.error(err);
// 	// 		alert("Mi spiace, si è verificato un errore.");
// 	// 	}
// 	// });
// });


Shark.registerComponent(exportPDFComponent);

export { exportPDFComponent };
